import type { LegalSection } from "./types";

export type TocEntry = {
  id: string;
  heading: string;
  depth: 1 | 2;
  sectionLabel: string;
};

export function buildTocEntries(sections: LegalSection[]): TocEntry[] {
  const entries: TocEntry[] = [];
  let autoNum = 0;

  for (const section of sections) {
    const fromId = section.id.replace(/^s/, "");
    let sectionLabel: string;
    if (/^\d+$/.test(fromId)) {
      sectionLabel = fromId;
      autoNum = Math.max(autoNum, Number.parseInt(fromId, 10));
    } else {
      autoNum += 1;
      sectionLabel = String(autoNum);
    }

    entries.push({
      id: section.id,
      heading: section.heading,
      depth: 1,
      sectionLabel,
    });

    for (const sub of section.subsections ?? []) {
      entries.push({
        id: sub.id,
        heading: sub.heading,
        depth: 2,
        sectionLabel: "—",
      });
    }
  }

  return entries;
}
